export default __webpack_public_path__ + "static/media/39t.0de5ac0c.jpg";